import { useContext } from 'react'
import { MealPlanResultsContext } from './MealPlanResultsContext'

export function useGetMealPlanResults() {
  const context = useContext(MealPlanResultsContext)

  if (!context) {
    throw new Error('useGetMealPlanResults must be used within MealPlanResultsProvider')
  }

  return context
}
